<template>
 <div class="bump squeeze">

    <v-data-table
      :headers="beMarket"
      :items="beMarketData"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
    <v-data-table
      :headers="beTransact"
      :items="beTransactData"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
    <v-data-table
      :headers="beAd"
      :items="beAdData"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
    <v-data-table
      :headers="beOn"
      :items="beOnData"
      hide-actions
      class="elevation-6"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
    <v-data-table
      :headers="beRev"
      :items="beRevData"
      hide-actions
      class="elevation-6 total-table"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
    <br>
    <v-data-table
      :headers="beCost"
      :items="beCostData"
      hide-actions
      class="elevation-6 total-table"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
    <br>
    <v-data-table
      :headers="beEbit"
      :items="beEbitData"
      hide-actions
      class="elevation-6 total-table"
      item-key="name"
    >
      <template slot="items" slot-scope="props">
        <tr @click="props.expanded = !props.expanded">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.one }}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat>
          <v-card-text>{{ props.item.notes }}</v-card-text>
        </v-card>
      </template>
    </v-data-table>
      <br>
</div>
</template>

<script>
export default {
  data() {
    return {
      beMarket: [
        {
          text: 'Market Maker Fee',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Year 2', value: 'one', sortable: false, align: 'right' }
      ],
      beTransact: [
        {
          text: 'Transaction Fee',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Year 2', value: 'one', sortable: false, align: 'right' }
      ],
      beAd: [
        {
          text: 'Advertising Revenue',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Year 2', value: 'one', sortable: false, align: 'right' }
      ],
      password: 'pawfin',
      beOn: [
        {
          text: 'Onboarding/Training Fee',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Year 2', value: 'one', sortable: false, align: 'right' }
      ],
      beRev: [
        {
          text: 'Total Revenue',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Year 2', value: 'one', sortable: false, align: 'right' }
      ],
      beCost: [
        {
          text: 'Total Costs',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Year 2', value: 'one', sortable: false, align: 'right' }
      ],
      beEbit: [
        {
          text: 'EBIT',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Year 2', value: 'one', sortable: false, align: 'right' }
      ],
      beMarketData: [
        {
          value: false,
          name: 'Total Capturable Pet Market',
          one: '281,600,000'
        },
        {
          value: false,
          name: 'Pawtocol Capture Rate On Platform',
          one: '0.08%'
        },
        {
          value: false,
          name: 'Pets on Pawtocol Platform',
          one: '220,000'
        },
        {
          value: false,
          name: 'Average Transactions Per Pet/Yr',
          one: '22'
        },
        {
          value: false,
          name: 'Average Value Per Data Transaction',
          one: '$3'
        },
        {
          value: false,
          name: 'Pawtocol Market Maker %',
          one: '2%'
        },
        {
          value: false,
          name: '',
          one: '$249,260'
        }
      ],
      beTransactData: [
        {
          value: false,
          name: 'Pet owners within capturable market',
          one: '177,240,000'
        },
        {
          value: false,
          name: 'Pawtocol Capture Rate On Platform',
          one: '0.08%'
        },
        {
          value: false,
          name: 'Pet Owners on the Pawtocol Platform',
          one: '138,469'
        },
        {
          value: false,
          name: 'Pet Owners Willing to Participate in Loyalty Points Systems',
          one: '110,775'
        },
        {
          value: false,
          name: 'Average US Yearly Pet Expenditure',
          one: '642'
        },
        {
          value: false,
          name: 'Maximum Value of Goods and Services Transacted on Network',
          one: '$71,091,812'
        },
        {
          value: false,
          name: 'Pawtocol Transaction Fee',
          one: '0.5%'
        },
        {
          value: false,
          name: '',
          one: '$355,459'
        }
      ],
      beAdData: [
        {
          value: false,
          name: 'Target Cat and Dog Population Annual Spend',
          one: '107,816,965,406'
        },
        {
          value: false,
          name: 'Digital Media Advertising Spend (Pet Industry) as a Percent of Industry Revenue',
          one: '1.50%'
        },
        {
          value: false,
          name: 'Total Capturable Digital Advertising Market',
          one: '$1,617,254,481'
        },
        {
          value: false,
          name: 'Pawtocol % Capture of Advertising Market',
          one: '0.08%'
        },
        {
          value: false,
          name: '',
          one: '$1,263,480'
        }
      ],
      beOnData: [
        {
          value: false,
          name: 'Price Per Day to Onboard',
          one: '$10,300'
        },
        {
          value: false,
          name: 'Average Number of Days to Onboard',
          one: '5'
        },
        {
          value: false,
          name: 'Pawtocol Onboard Capacity per Year',
          one: '10.9375'
        },
        {
          value: false,
          name: '',
          one: '$563,281'
        }
      ],
      beRevData: [
        {
          value: false,
          name: '',
          one: '$2,431,480'
        }
      ],
      beCostData: [
        {
          value: false,
          name: '',
          one: '$2,451,176.00'
        }
      ],
      beEbitData: [
        {
          value: false,
          name: '',
          one: '-$19,696'
        }
      ]
    }
  }
}    
</script>

<style>
  
</style>